import React from "react";

export default function CallSection() {
    return(
        <>
        {/* CALL TO ACTION START (call-to-action-6) */}
        <div
          className="ltn__call-to-action-area call-to-action-6 before-bg-bottom"
          data-bs-bg="img/1.jpg--"
        >
          <div className="container-fluid">
            <div className="row" style={{padding:"0 4%"}}>
              <div className="col-lg-12">
                <div className="call-to-action-inner call-to-action-inner-6 ltn__secondary-bg position-relative text-center---">
                  <div className="coll-to-info text-color-white">
                    <h1>
                      Buy medical disposable face mask <br /> to protect your loved
                      ones
                    </h1>
                  </div>
                  <div className="btn-wrapper">
                    <a className="btn btn-effect-3 btn-white" href="/shop">
                      Explore Products <i className="icon-next" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* CALL TO ACTION END */}
      </>      
    );

}   